module.exports = __webpack_public_path__ + "assets/images/dancando.e6730046.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dancando.jpg
// module id = 808
// module chunks = 1